import { render, staticRenderFns } from "./Wap.vue?vue&type=template&id=6de4bb27&scoped=true&"
import script from "./Wap.vue?vue&type=script&lang=js&"
export * from "./Wap.vue?vue&type=script&lang=js&"
import style0 from "./Wap.vue?vue&type=style&index=0&id=6de4bb27&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6de4bb27",
  null
  
)

export default component.exports